import { render, staticRenderFns } from "./Glue.vue?vue&type=template&id=99893e62&"
import script from "./Glue.vue?vue&type=script&lang=js&"
export * from "./Glue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports